import { openBlock as t, createElementBlock as c, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, l = /* @__PURE__ */ e("path", { d: "M8.619 6.951c.019-.279-.174-.522-.425-.522h-.377c-.24 0-.444.234-.424.522l.154 2.46c.02.262.213.46.435.46h.057c.222 0 .406-.198.425-.46l.155-2.46Zm.009 4.245c0-.315-.28-.577-.617-.577-.338 0-.618.262-.618.577 0 .316.28.577.618.577.337 0 .617-.261.617-.577Z" }, null, -1), n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M1.842 14.414H14.16v-.01c.724 0 1.322-.567 1.322-1.261a1.2 1.2 0 0 0-.173-.631L9.11 2.22a1.287 1.287 0 0 0-.82-.595 1.372 1.372 0 0 0-1.014.144c-.193.118-.348.27-.463.46L.694 12.521c-.358.604-.155 1.352.472 1.712.203.117.435.18.676.18Zm.174-1.334L7.972 3.076l6.004 9.986-11.96.018Z",
  "clip-rule": "evenodd"
}, null, -1), r = [
  l,
  n
];
function d(s, a) {
  return t(), c("svg", o, [...r]);
}
const _ = { render: d };
export {
  _ as default,
  d as render
};
